import styled from 'styled-components';

export const RoundedGravatar = styled.svg`
    image {
        clip-path: inset(0% round 50%);
    }
`;
